import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Seattle needed",
      "Ideal for North Idaho College & NIC students",
      "Great for Lake Coeur d'Alene resort & tourism professionals",
      "Perfect for Inland Northwest remote workers & entrepreneurs",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Coeur d'Alene post offices",
      "Good for planned international travel from GEG",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Kootenai County facilities",
      "Workload shifts with government shutdowns and budget fights",
      "Mail routing through Spokane hub adds possible delays",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Idaho has zero passport agencies — closest is Seattle (~300 mi, 5+ hr via I-90) or San Francisco (~730 mi via I-5)",
      "NPIC appointment required before traveling to Seattle",
      "Life-or-death emergencies only — bereavement or medical crisis documentation required",
      "Winter conditions on Snoqualmie Pass can close I-90 entirely, making Seattle inaccessible by car for days",
      "Expect to wait all day or return next day at the agency",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function ProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Coeur d'Alene"
      headingExtra="ID"
      introText="Coeur d'Alene and North Idaho travelers — resort hospitality professionals, the growing Inland Northwest remote workforce, lake tourism industry workers, and Kootenai County residents who know Seattle isn't exactly around the corner — have several options for getting a passport fast. Here is how they compare, and why most choose a U.S. Department of State registered passport courier for predictable processing without the drive over Snoqualmie Pass."
      options={options}
      emergencyDescription="Idaho has zero passport agencies. The closest is Seattle (~300 miles, 5+ hour drive via I-90). However, Snoqualmie Pass on I-90 closes regularly during winter storms, making Seattle inaccessible by car for days at a time. The next closest is San Francisco (~730 miles, 11+ hours). Flight from GEG (Spokane) adds $200+. You must obtain an NPIC appointment before traveling — walk-ins are not accepted."
      disclaimerText="*Processing speed depends on eligibility and documentation. Idaho has no regional passport agency — the closest is Seattle. Not all applicants qualify for Regional Agency Processing."
    />
  );
}